//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfBadge from "~/themes/fiskarsMoominDefault/components/components/atoms/SfBadge/SfBadge.vue";
import SfPrice from "~/themes/fiskarsMoominDefault/components/components/atoms/SfPrice/SfPrice.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfInput from "~/themes/fiskarsMoominDefault/components/components/atoms/SfInput/SfInput.vue";
import SfLoader from "~/themes/fiskarsMoominDefault/components/components/atoms/SfLoader/SfLoader.vue";
import ProductHeader from "~/components/productHeader.vue";
import { reactive, ref, computed, onMounted, watch, useContext } from "@nuxtjs/composition-api";
import LazyHydrate from "vue-lazy-hydration";
import { validateEmail, markFieldAsTouched, touchedState, isFormValidated } from "~/helpers/validation-utils";
import { getCMSLabels, getCMSItem } from "~/helpers/globalLabels";
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import { adaptProduct } from "~/helpers/analytics/helper";
import { handleImageError } from "~/common";
import SfAddToCart from "~/themes/fiskarsMoominDefault/components/components/molecules/SfAddToCart/SfAddToCart.vue";
import MoominLink from '~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue';
import { useUserStore } from '~/stores/user-store';
import SocialMediaSlider
  from "~/themes/fiskarsMoominDefault/components/components/molecules/SocialMediaSlider/SocialMediaSlider.vue";
import { setKlarnaScript } from "~/composables";
export default {
  name: "MoominProductDetails",
  transition: "fade",
  components: {
    SocialMediaSlider,
    SfAddToCart,
    LazyHydrate,
    SfLoader,
    SfBadge,
    SfPrice,
    SfButton,
    SfInput,
    ProductHeader,
    MoominLink,
    SfCarousel: () => import("~/themes/fiskarsMoominDefault/components/components/organisms/SfCarousel/SfCarousel.vue"),
    SfAccordion: () => import("~/themes/fiskarsMoominDefault/components/components/organisms/SfAccordion/SfAccordion.vue"),
    ProductGallery: () => import("~/components/Product/ProductGallery"),
  },
  props: {
    badges: {
      type: Array,
      default: () => [],
    },
    callouts: {
      type: Array,
      default: () => [],
    },
    productDetails: {
      type: Object,
      default: () => {},
    },
    collection: {
      type: Object,
      default: () => {},
    },
    delivery: {
      type: Object,
      default: () => {},
    },
    features: {
      type: Object,
      default: () => {},
    },
    specifications: {
      type: Object,
      default: () => {},
    },
    images: {
      type: Array,
      default: () => [],
    },
    galleryImages: {
      type: Array,
      default: () => [],
    },
    outOfStock: {
      type: Object,
      default: () => ({
        status: true,
        title: "Out of stock! - Sorry, this product is currently out of stock!",
        label: "Please notify me when it’s available.",
        info: "We use your email address to inform you about the availability of this product. We won’t use your email for marketing purposes. View our Privacy policy.",
        button: "Notify me",
      }),
    },
    emailCMS: {
      type: Object,
      default: () => ({
        value: "",
        placeholder: "Email address",
        error: false,
        errorMessage: "Please update your email",
      }),
    },
    error: {
      type: Object,
      default: () => ({}),
    },

    addToCartButton: {
      type: String,
      default: "Add to cart",
    },
    seeCollection: {
      type: String,
    },
    cartLoader: {
      type: Boolean,
      default: false,
    },
    notifyMeLoader: {
      type: Boolean,
      default: false,
    },
    isMaxLimitReached: {
      type: Boolean,
      default: false,
    },
    isAddtoCartHidden:{
      type: Boolean,
      default: false
    },
    productInfo: {
      type: Object,
      default: () => ({}),
    },
    discountPercentage:{
      type:Number,
    },
    checkOnlyAvailableTo:{
      type: String,
    },
    socialMediaSiteNameId: String,
  },
  methods: {
    checkContainsHTML(text) {
      const regex = /<[a-z][\s\S]*>/i;
      return regex.test(text);
    },
  },
  setup(props, { emit }) {
    const { i18n } = useContext();
    const userStore = useUserStore();
    const quantity = ref(1);
    const email = ref(props.emailCMS.value ?? "");

    const carouselSettings = reactive({
      type: "carousel",
      rewind: true,
      perView: 1,
      slidePerPage: true,
      direction: "ltr",
      gap: 70,
      throttle: 100,
      breakpoints: {
        1023: {
          perView: 1,
          gap: 10,
          peek: {
            before: 0,
            after: 0,
          },
        },
        767: {
          perView: 1,
          autoplay: 0,
        },
        510: {
          perView: 1,
          autoplay: 0,
        },
      },
    });

    const outOfStockEmailPlaceholder = computed(
      () => props.emailCMS?.placeholder
    );
    const outOfStockTooltip = computed(() => props.emailCMS?.info);
    const outOfStockLabel = computed(() =>
      getCMSLabels("product-details-notityme-text")
    );
    const outOfStockButton = computed(() => props?.outOfStock?.button);
    const outOfStockTitle = computed(() => props?.outOfStock?.title);
    const privacyPolicy = computed(() => props?.outOfStock?.privacyPolicy);
    const outOfStockDisclaimerUrl = computed(() => props?.outOfStock?.disclaimerUrl);
    const outOfStockDisclaimer = computed(() => props?.outOfStock?.disclaimer);

    const getLowestPriceLabel = computed(() => getCMSLabels("lowestprice"));

    const quantityMaxLimitReachedError = getCMSLabels('maximum-number');
    const quantityMinLimitReachedError = getCMSLabels('minimum-number');

    const badgeColorDiscountPercentage = getCMSItem('badge-color-discount-percentage') || "#FBAFA0";

    const formValues = reactive({
      email: {
        touched: touchedState(email.value),
        value: () => email.value,
        validation: computed(() => {
          if (!formValues.email.touched) return { valid: true, error: "" };
          const result = validateEmail(email.value, outOfStockEmailPlaceholder.value);
          return {
            valid: result.isValid,
            error: result.isValid ? "" : result.errorMessage || props.emailCMS?.errorMessage,
          };
        }),
      },
    });

    const canSubmit = computed(() => !!isFormValidated(formValues));

    const submit = () => {
      if (canSubmit.value) {
        emit("processNotifyme", {
          value: email.value,
          placeholder: "Email address",
          error: false,
          errorMessage: "",
        });
      } else {
        emit("processNotifyme", {
          value: email.value,
          placeholder: "Email address",
          error: true,
          errorMessage: "Please update your email",
        });
      }
    };

    const product = computed(() =>
      Object.keys(props.productInfo).reduce((acc, key) => {
        acc[key.toLowerCase()] = props.productInfo[key];
        quantity.value = props.productInfo["minQty"];
        return acc;
      }, {})
    );

    const showQuantityLimitError = (error = '') => {
      return error == 'minQtyReached' ?  quantityMinLimitReachedError.replace('{0}', product?.value?.minallowedQtyToShow) : quantityMaxLimitReachedError.replace('{0}', product?.value?.maxallowedqtytoshow);
    }
    const shouldShowBothPrice = computed(() => {
      const { price_regular, price_discounted } = product?.value?.raw;
      return price_regular > 0 && price_discounted > 0;
    });

    const shouldShowPrice = computed(() => {
      const { price_regular } = product?.value?.raw;
      return price_regular > 0;
    });

    const shouldShowLowestPrice = computed(() => {
      const { lowest_price, price_discounted,price_regular } = product?.value?.raw;
      return lowest_price > 0 && price_discounted > 0 && price_regular !== price_discounted ;
    });

    const productForEvent = computed(() => {
        if ( product.value.analytics )
          return adaptProduct( product.value.analytics, "MoominProductDetails" )
      }
    );

    const productId = computed(() => product.value?.analytics?.id);

    const trackingDataSent = ref(false);

    watch(product, newVal => {
      if(newVal?.analytics?.id && !trackingDataSent.value) {
        analyticsEvents.productViewed(newVal.analytics);
        trackingDataSent.value = true;
      }
    });

    const addToCart = () => {
      emit("processAddToCart", {
        qty: quantity.value,
        productForEvent: productForEvent.value,
      });
    };

    const getDiscountPercentageText = computed(() => {
        return `-${props.discountPercentage}%`
      });




    const getExclusivePriceBadgeText = computed(() => {
      const isUserLoggedIn = userStore.getUserIsLoggedIn;
      const hasExclusivePrice = product.value?.exclusiveprice.value > 0;

      if (hasExclusivePrice) {
        const discountPrice = isUserLoggedIn
          ? '' // Logged-in user
          : product.value?.exclusiveprice.formattedValue;

        const exclusivePriceLabelText = getCMSLabels('my-moomin-price') || 'MyMoomin Price (hardcoded)';

        return `${exclusivePriceLabelText}${isUserLoggedIn ? '' : `: ${discountPrice}`}`;
      }

      // No exclusive price
      return '';
    });

    const returnKlarnaDataLocale = computed(() => `${i18n.localeProperties.language}-${i18n.localeProperties.countryCode}`)

    onMounted(async () => {
      await setKlarnaScript();
      window['Klarna']?.OnsiteMessaging?.refresh()
    })

    return {
      returnKlarnaDataLocale,
      email,
      productId,
      product,
      carouselSettings,
      quantity,
      formValues,
      markFieldAsTouched,
      outOfStockEmailPlaceholder,
      outOfStockTooltip,
      outOfStockLabel,
      outOfStockButton,
      outOfStockTitle,
      outOfStockDisclaimer,
      outOfStockDisclaimerUrl,
      privacyPolicy,
      addToCart,
      handleImageError,
      shouldShowPrice,
      shouldShowBothPrice,
      shouldShowLowestPrice,
      getLowestPriceLabel,
      showQuantityLimitError,
      userStore,
      getExclusivePriceBadgeText,
      getDiscountPercentageText,
      badgeColorDiscountPercentage,
      canSubmit,
      submit
    };
  },
};
